import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import {getMessage} from './../../utils/i18n';

class Logo extends Component {

    render() {
        return (
            <div className="foLogo">
                <Link
                    className="foLogoLink"
                    to="/"
                    dangerouslySetInnerHTML={{
                        __html: getMessage(
                            'app.brand.welcome',
                            [
                                `<span class="foOrg">${getMessage('app.brand.name')}</span>`,
                                `<span class="foSuite">${getMessage('app.brand.suite')}</span>`
                            ]
                        )
                    }}/>
            </div>
        );
    };

}

export default Logo;


// WEBPACK FOOTER //
// ./src/app/components/header/logo.js